export default __webpack_public_path__ + "static/media/ferBlog.40baa1c2.png";